import { useState, useEffect } from "react";
import { SELECTED_ORG_ID_KEY } from "../components/common/constant";

export const useSelectedOrgId = () => {
  const [value, setValue] = useState(() => {
    const storedValue = localStorage.getItem(SELECTED_ORG_ID_KEY);
    return storedValue ? JSON.parse(storedValue) : undefined;
  });

  useEffect(() => {
    const handleStorageChange = () => {
      const storedValue = localStorage.getItem(SELECTED_ORG_ID_KEY);
      setValue(storedValue ? JSON.parse(storedValue) : undefined);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return [value];
};
